<template>
  <sub-page title="企业养老保险待遇发放账户变更">
    <div class="change-page">
      <!-- 当前发放账户 -->
      <div class="section-title">当前发放账户</div>
      <div class="form-body">
        <div class="form-item">
          <span class="form-label">发放方式</span>
          <span class="form-value">社会保障卡金融账户</span>
        </div>
        <div class="form-item">
          <span class="form-label">开户银行</span>
          <span class="form-value">中国工商银行南京江北新区支行</span>
        </div>
        <div class="form-item">
          <span class="form-label">银行账号</span>
          <span class="form-value">6222 **** **** 5619</span>
        </div>
        <div class="form-item">
          <span class="form-label">账户状态</span>
          <span class="form-value txt-green">正常</span>
        </div>
      </div>

      <!-- 变更后信息 -->
      <div class="section-title">变更后信息</div>
      <div class="form-body">
        <div class="form-item">
          <span class="form-label required">发放方式</span>
          <span class="form-value">社会保障卡金融账户</span>
        </div>
        <div class="form-item">
          <span class="form-label required">开户银行</span>
          <input v-model="form.bank" class="form-input" placeholder="请输入开户银行全称（如：中国工商银行XX支行）" />
        </div>
        <div class="form-item">
          <span class="form-label required">银行账号</span>
          <input v-model="form.account" class="form-input" type="tel" maxlength="19" placeholder="请输入社会保障卡金融账号" />
        </div>
        <div class="form-item">
          <span class="form-label required">确认账号</span>
          <input v-model="form.account2" class="form-input" type="tel" maxlength="19" placeholder="请再次输入银行账号" />
        </div>
        <div class="form-item">
          <span class="form-label required">预留手机号</span>
          <input v-model="form.mobile" class="form-input" type="tel" maxlength="11" placeholder="请输入银行预留手机号" />
        </div>
      </div>

      <div class="tip-line">提示：待遇将发放至本人社会保障卡金融账户，请确认账号已在银行激活金融功能。</div>

      <div class="footer-btn">
        <button class="submit-btn" @click="handleSubmit">提交变更申请</button>
      </div>
    </div>
  </sub-page>
</template>

<script>
import SubPage from './SubPage.vue'

export default {
  name: 'PensionAccountChange',
  components: { SubPage },
  data() {
    return {
      form: {
        bank: '',
        account: '',
        account2: '',
        mobile: ''
      }
    }
  },
  methods: {
    handleSubmit() {
      const f = this.form
      if (!f.bank) { this.$alert('请输入开户银行全称'); return }
      if (!f.account) { this.$alert('请输入银行账号'); return }
      if (!/^\d{12,19}$/.test(f.account)) { this.$alert('请输入正确的银行账号'); return }
      if (f.account !== f.account2) { this.$alert('两次输入的银行账号不一致'); return }
      if (!/^1[3-9]\d{9}$/.test(f.mobile)) { this.$alert('请输入正确的预留手机号'); return }
      this.$alert('账户变更申请已提交，社保经办机构审核通过后次月起按新账户发放')
    }
  }
}
</script>

<style scoped>
.change-page {
  background: #F3F8FB;
  min-height: 100%;
  padding-bottom: calc(40 * var(--w));
}
.section-title {
  font-size: calc(30 * var(--w));
  font-weight: bold;
  color: #323233;
  padding: calc(28 * var(--w)) calc(32 * var(--w)) calc(16 * var(--w));
}
.form-body {
  background: #fff;
}
.form-item {
  display: flex;
  align-items: center;
  min-height: calc(110 * var(--w));
  padding: 0 calc(32 * var(--w));
  border-bottom: 1px solid #f0f0f0;
  gap: calc(24 * var(--w));
}
.form-item:last-child {
  border-bottom: none;
}
.form-label {
  font-size: calc(30 * var(--w));
  color: #323233;
  white-space: nowrap;
  width: calc(200 * var(--w));
  flex-shrink: 0;
}
.form-label.required::before {
  content: '*';
  color: #f00;
  margin-right: calc(4 * var(--w));
}
.form-value {
  flex: 1;
  font-size: calc(30 * var(--w));
  color: #323233;
}
.txt-green {
  color: #07A35A;
}
.form-input {
  flex: 1;
  height: calc(110 * var(--w));
  border: none;
  outline: none;
  font-size: calc(30 * var(--w));
  color: #323233;
  background: transparent;
}
.form-input::placeholder {
  color: #969799;
}
.tip-line {
  padding: calc(24 * var(--w)) calc(32 * var(--w)) 0;
  font-size: calc(26 * var(--w));
  color: #969799;
  line-height: 1.7;
}
.footer-btn {
  padding: calc(40 * var(--w)) calc(32 * var(--w));
}
.submit-btn {
  width: 100%;
  height: calc(88 * var(--w));
  background: #2E8CF6;
  color: #fff;
  font-size: calc(36 * var(--w));
  border: none;
  border-radius: calc(8 * var(--w));
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/PensionAccountChange.vue